export default __webpack_public_path__ + "static/media/s6.aca2ab9c.jpeg";